import {labels} from '../../../util/utils';
import env from '../../../util/env';

function noop() {}

function log(message) {
	console.log('SignalR: ' + message);
}

// Wrap custom object returned by jQuery ajax
function promisify(ajax) {
	return new Promise((resolve, reject) => ajax.done(() => resolve()).fail(reject));
}

function restart(hub, reason) {
	log(reason);

	setTimeout(() => promisify(hub.start()).then(() => log('Hub Reconnected')), 10 * 1000);
}

function monitor(hub) {
	if (!hub) return null;

	// Restart if TrayApp is closed
	hub.disconnected(() => restart(hub, 'Hub Disconnected')).connectionSlow(() => restart(hub, 'Slow Connection'));

	return hub;
}

function hubLoaded(config, eventHandlers) {
	if (!$.connection) return Promise.reject(new Error('jQuery connection not available!'));

	const customHub = $.connection[config.hubName];

	if (!customHub) return Promise.reject(['0010', 'Connection Failed', labels.documentHelperConnectionIssue]);

	const defaultHub = $.connection.hub;

	defaultHub.logging = true;
	defaultHub.url = config.SignalRHubUrl;

	customHub.connection.on = customHub.on.bind(customHub);

	$.extend(customHub.client, {
		addDocumentError: noop,
		addDocumentComplete: noop,
		downloadProgress: noop,
		downloadComplete: noop,
		downloadCanceled: noop,
		...eventHandlers
	});

	return promisify(defaultHub.start()).then(() => {
		monitor(defaultHub);
		return customHub.connection;
	});
}

export default function getConnection(eventHandlers) {
	const config = env.getDocHelperConfig();

	// Scripts need to be downloaded in sequence
	return promisify($.ajax({url: config.SignalRHubUrl, dataType: 'script'})).then(() =>
		hubLoaded(config, eventHandlers)
	);
}
